import React, { useId } from 'react';

/**
 * Canlı destek butonunun varsayılan ikonu.
 *
 * Panelde ikon yüklenmediği sürece görünen budur. Kuruluma özel bir görsel
 * yerine nötr bir kulaklık simgesi çizer ve renklerini tema değişkenlerinden
 * alır (`--pusu-gold` / `--pusu-on-accent`, App.css) — böylece her kurulum
 * kendi ana rengiyle açılır. `accent` / `foreground` verilirse değişkenlerin
 * yerine onlar kullanılır (panel önizlemesi böyle yapar).
 */
const LiveChatDefaultIcon = ({
  className = '', style, accent, foreground,
}) => {
  const bg = accent || 'var(--pusu-gold, #c71a1a)';
  const fg = foreground || 'var(--pusu-on-accent, #ffffff)';
  // Aynı sayfada birden çok kopya çizilebildiği için gradient kimliği tekil.
  const shineId = `livechat-icon-shine-${useId()}`;

  return (
    <svg
      className={className}
      style={style}
      viewBox="0 0 96 96"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        {/* Üstten gelen hafif ışık, düz dolgulu daireye hacim verir */}
        <linearGradient id={shineId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#ffffff" stopOpacity="0.22" />
          <stop offset="0.6" stopColor="#ffffff" stopOpacity="0" />
          <stop offset="1" stopColor="#000000" stopOpacity="0.12" />
        </linearGradient>
      </defs>
      <circle cx="48" cy="48" r="48" fill={bg} />
      <circle cx="48" cy="48" r="48" fill={`url(#${shineId})`} />
      <circle
        cx="48"
        cy="48"
        r="42.5"
        fill="none"
        stroke={fg}
        strokeOpacity="0.35"
        strokeWidth="2"
      />
      <g transform="translate(-4.8 -12.5) scale(1.1)">
        {/* Kulaklık bandı ve mikrofon kolu */}
        <g
          fill="none"
          stroke={fg}
          strokeWidth="4.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M30 52v-6a18 18 0 0 1 36 0v6" />
          <path d="M65.5 70v4a7 7 0 0 1-7 7h-4" />
        </g>
        <g fill={fg}>
          <rect x="25" y="50" width="11" height="20" rx="5.5" />
          <rect x="60" y="50" width="11" height="20" rx="5.5" />
          <rect x="42" y="77" width="12" height="8" rx="4" />
        </g>
      </g>
    </svg>
  );
};

export default LiveChatDefaultIcon;
